import { Toast } from 'vant';

const toast = Toast;

export default toast;